"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.API_LINK = void 0;
exports.API_LINK = 'https://captcha-api.yandex.ru/captcha.js?render=onload&onload=__onSmartCaptchaReady';
